import { render, staticRenderFns } from "./UrlTestModal.vue?vue&type=template&id=b2c8018e&scoped=true&"
import script from "./UrlTestModal.vue?vue&type=script&lang=js&"
export * from "./UrlTestModal.vue?vue&type=script&lang=js&"
import style0 from "./UrlTestModal.vue?vue&type=style&index=0&id=b2c8018e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c8018e",
  null
  
)

export default component.exports